import React from "react";
import { arrLanguages, TemplateStatusChip, Grid, Typography, Button, Divider, Paper, makeStyles, SettingsBackupRestoreIcon, EditIcon, DeleteIcon, LibraryAddIcon, MouseOverPopover } from "../../..";
import { Chip } from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
var useStyles = makeStyles(function (theme) {
  return {
    flexCenter: {
      display: "flex",
      "align-items": "center"
    },
    itemEdit: {
      display: "flex",
      alignItems: "center"
    },
    chip: {
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px"
    }
  };
});

var TemplatesTemplateInfo = function TemplatesTemplateInfo(props) {
  var classes = useStyles(); // console.log("props info", props);

  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      marginTop: "16px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8,
    className: classes.flexCenter
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, props.languages && props.languages["es"].name), /*#__PURE__*/React.createElement(TemplateStatusChip, {
    status: props.status,
    style: {
      "margin-left": "20px"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: "Best practice"
  }, /*#__PURE__*/React.createElement(StarIcon, {
    style: {
      color: props.isBestPractice ? "#77ffb5" : "#e2e2e2",
      margin: "8px"
    },
    onClick: props.handleBestPracticeTemplate
  })), props.status !== "building" && /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: "Restart template"
  }, /*#__PURE__*/React.createElement(SettingsBackupRestoreIcon, {
    color: "secondary",
    style: {
      margin: "8px"
    },
    onClick: props.handleModalRestartTemplate
  })), /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: "Delete template"
  }, /*#__PURE__*/React.createElement(DeleteIcon, {
    color: "secondary",
    style: {
      margin: "8px"
    },
    onClick: props.handleModalDeleteTemplate
  })), (props.status === "building" || props.status === "draft" || props.status === "published") && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    style: {
      margin: "8px",
      marginRight: "36px"
    },
    onClick: function onClick() {
      return props.handleModalChangeStatusTemplate(props.status);
    }
  }, props.status === "building" ? "Change to draft" : props.status === "draft" ? "Publish" : "Change to draft")))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    style: {
      padding: "16px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 10
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Description"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.languages && props.languages["es"].description)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.itemEdit
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Type"), /*#__PURE__*/React.createElement(EditIcon, {
    style: {
      color: "#ffe082",
      margin: "8px"
    },
    onClick: props.handleModalEditType
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.type ? props.type.toUpperCase() : "Undefined"), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      margin: "16px 0"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flexCenter
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Languages"), props.status !== "building" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: "Add new language"
  }, /*#__PURE__*/React.createElement(LibraryAddIcon, {
    style: {
      marginLeft: "16px"
    },
    variant: "contained",
    color: "primary",
    onClick: props.handleModalAddLanguage
  })))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      margin: "0",
      "padding-top": "15px"
    }
  }, props.languages && Object.keys(props.languages).map(function (language) {
    return arrLanguages.find(function (_language) {
      return _language.value === language;
    }) ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 4,
      style: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginRight: "16px"
      }
    }, arrLanguages.find(function (_language) {
      return _language.value === language;
    }).label), /*#__PURE__*/React.createElement(TemplateStatusChip, {
      status: props.languages[language].status
    })) : {
      label: "undefined" + language,
      value: language
    };
  }))))));
};

export { TemplatesTemplateInfo };